import '@fontsource/archivo/400.css';
import '@fontsource/archivo/500.css';
import '@fontsource/archivo/600.css';
import '@fontsource/archivo/700.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import './styles/globals.css';
// Depois dos estilos do @taskall/react (overrides de tom usam a mesma especificidade).
import '@taskall/ui/styles.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';

// Este app não usa service worker: remove qualquer SW/cache herdado de outro app na mesma origem.
if ('serviceWorker' in navigator) {
  void navigator.serviceWorker.getRegistrations().then((regs) => regs.forEach((r) => void r.unregister()));
  if ('caches' in window) void caches.keys().then((keys) => keys.forEach((k) => void caches.delete(k)));
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
